module.exports = __webpack_public_path__ + "img/Card Collection Cover Placeholder.44ef263a.jpeg";